export default __webpack_public_path__ + "static/media/xillon.06584f86.jpg";